export const environment = {
  production: true,
  mlRoot: 'https://dev.api.ml.beyondmultiplechoice.org/api/',
  apiRoot: 'https://dev.api.ml.beyondmultiplechoice.org/api/',
  // drupalSiteUrl: 'https://dev-beyondmultiplechoice.pantheonsite.io',
  drupalSiteUrl: 'https://beyondmultiplechoice.org/',
  questionsApiToken: '09e0ab15-47ea-4fd7-dbaa-880867a0e09a',
  functionsApiToken: '1e38b9ee-c0a2-4224-8573-016e3f8314f2',
  generalApiToken: '0fd93a1f-b213-4064-b68d-76f82ebaef6f'
};
